<template>
  <div class="wrapper">
    <lastpage v-if="lastflag" :homeShow="false"></lastpage>
    <ul class="title_list">
      <li class="title">基本信息</li>
      <li>
        <span>姓名：</span>
        <span>{{ list[0].patientName }}</span>
      </li>
      <li>
        <span>年龄：</span>
        <span>{{ list[0].age }}岁</span>
      </li>
    </ul>
    <div class="cf_list">
      <span class="title">费用明细</span>
      <ul class="content" v-for="(item,index) in list2" :key="index">
        <li class="keshi">
          <span>
            <span>处方号：</span>
            <span>{{ item.rcptNo }}</span>
          </span>
          <span>
            <span>开方科室：</span>
            <span>{{ item.deptName }}</span>
          </span>
          <span>
            <span>开方医生：</span>
            <span>{{ item.doctorName }}</span>
          </span>
          <span>
            <span>处方金额：</span>
            <span>{{ item.totalMoney }}元</span>
          </span>
        </li>
        <ul class="xiangmu">
          <li>
            <span>项目名称</span>
            <span>单价(元)</span>
            <span>数量</span>
            <span>金额(元)</span>
          </li>
          <li v-for="(it) in item.ouRecipeDtlview" :key="it.itemCode">
            <span>{{ it.itemName }}</span>
            <span>{{ Number(it.unitPrice) }}</span>
            <span>{{ Number(it.amount) }}</span>
            <span>{{ Number(it.detailCost) }}</span>
          </li>
        </ul>
      </ul>
    </div>
  </div>
</template>

<script>
import { getPayedRecipeDtl } from "@/request/api.js";
import { GetRequest } from "@/tool/parameter.js";
import lastpage from "@/components/lastpage/lastpage.vue";
import { toUint8Array } from 'js-base64';
export default {
  components: {
    lastpage
  },
  data() {
    return {
      info: {},
      list: [],
      list2: [],
      lastflag: true
    }
  },
  created() {
    this.info = JSON.parse(sessionStorage.getItem("payedRecipe"));
    this.getList();
  },
  methods: {
    async getList(){
      if (GetRequest("billNo") == undefined) {
        this.lastflag = true;
        this.getinfo(this.info.billNo);
      } else {
        this.lastflag = false;
        this.getinfo(GetRequest("billNo"));
      }
    },

    async getinfo(billNo){
      let res = await getPayedRecipeDtl({billNo});
      this.list = res.data.obj.resultData
      this.list2 = this.list[0].ouRecipeView
    }
  },
}
</script>

<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  background: #f8f8f8;
  overflow: auto;
  .title_list{
    display: flex;
    flex-flow: row wrap;
    background: #fff;
    // margin-top: 10px;
    font-size: 16px;
    font-family: "华文楷体";
    >li{
      width: 50%;
      padding: 6px 20px 6px 10px;
      display: flex;
      flex-flow: row nowrap;
      >span:nth-child(2){
        color: rgb(128, 128, 128);
      }
      >span:nth-child(1){
        font-weight: bold;
      }
    }
  }
  .title{
    width: 100% !important;
    border-width: 0px;
    font-weight: bold;
    font-size: 18px;
    padding: 6px 20px 6px 10px;
    background:repeating-linear-gradient(to right,rgb(160, 193, 255),rgb(227, 245, 255));
    color: #fff;
    letter-spacing: 1px;
  }
  .cf_list{
    font-family: "华文楷体";
    display: flex;
    flex-flow: column nowrap;
    margin-top: 20px;
    .content{
      margin: 10px;
      padding: 10px;
      background: #fff;
      border-radius: 10px;
      .keshi{
        display: flex;
        flex-flow: row wrap;
        border-bottom: 1px solid #ddd;
        >span{
          width: 50%;
          margin-bottom: 6px;
          font-size: 14px;
          >span:nth-child(2){
            color: rgb(128, 128, 128);
          }
          >span:nth-child(1){
            font-weight: bold;
          }
        }
      }
      .xiangmu{
        margin-top: 6px;
        display: flex;
        flex-flow: column nowrap;
        >li{
          display: flex;
          flex-flow: row nowrap;
          justify-content: space-between;
          align-items: center;
          >span:nth-child(1){
            width: 40%;
            text-align: left;
            margin-top: 4px;
          }
          >span{
            width: 16%;
            text-align: center;
          }
        }
        >li:nth-child(1){
          font-weight: bold;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index/paymentRecordDetails.vue